import {Injectable} from '@angular/core';
import {Policy} from '../../shared/models/policy.model';
import {EntityState, SignalEntityStore} from '../../shared/state/signal-entity.store';

export interface PolicyState extends EntityState<Policy> { }

@Injectable({ providedIn: 'root' })
export class PolicyStore extends SignalEntityStore<Policy, PolicyState> {
  constructor() {
    super({name: 'policies', idKey: 'policy_id'});
  }
}
